import { useQuery } from '@tanstack/react-query';

import { fetchPendingApplicationsCount } from '@/lib/applicationQueueCount';

export const pendingApplicationsCountQueryKey = ['pending-applications-count'] as const;

export const usePendingApplicationsCount = () =>
  useQuery({
    queryKey: pendingApplicationsCountQueryKey,
    queryFn: fetchPendingApplicationsCount,
    staleTime: 30_000,
  });
